export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-900 text-background-50/80">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">土豪漫画</h4>
            <p className="text-sm text-background-50/50 leading-relaxed">
              国内领先的免费漫画在线阅读平台，汇聚韩漫、日漫、国漫海量资源，为你提供极致的下拉式阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="space-y-2">
              {[
                { label: '热门话题', href: '#topics' },
                { label: '最新更新', href: '#updates' },
                { label: '热门排行', href: '#ranking' },
                { label: '精选推荐', href: '#cards' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => { e.preventDefault(); scrollTo(item.href); }}
                  className="block text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">漫画分类</h4>
            <div className="space-y-2">
              {['韩漫专区', '日漫专区', '国漫专区', '主题索引'].map((item) => (
                <a
                  key={item}
                  href="#index"
                  onClick={(e) => { e.preventDefault(); scrollTo('#index'); }}
                  className="block text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {item}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-50/50 leading-relaxed">
              更多合作站点即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/40">
            &copy; 2019 - {new Date().getFullYear()} 土豪漫画网 TuHaoManHua. All Rights Reserved.
          </p>
          <div className="flex items-center gap-2 text-xs text-background-50/40">
            <span>韩漫</span>
            <span className="text-background-50/20">|</span>
            <span>日漫</span>
            <span className="text-background-50/20">|</span>
            <span>国漫</span>
            <span className="text-background-50/20">|</span>
            <span>免费漫画</span>
            <span className="text-background-50/20">|</span>
            <span>在线阅读</span>
          </div>
        </div>
      </div>
    </footer>
  );
}